module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0116.jpg?v=b75623da";